import {GetSnapshotCategory,GetNoTJ,GetSearchWZ,GetTJ,GetWZdetail,GetquestionList,GetcdList,PostSnapshot} from '@/api/CasualPatting'

const CasualPatting = {
  state: {

  },
  mutations: {

  },
  actions: {
    getquestionList({commit},params){
      return new Promise((resolve, reject) => {
        GetquestionList(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getSearchWZ({commit},params){
      return new Promise((resolve, reject) => {
        GetSearchWZ(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getWZdetail({commit},params){
      return new Promise((resolve, reject) => {
        GetWZdetail(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTJ({commit},params){
      return new Promise((resolve, reject) => {
        GetTJ(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getNoTJ({commit},params){
      return new Promise((resolve, reject) => {
        GetNoTJ(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getcdList({commit},params){
      return new Promise((resolve, reject) => {
        GetcdList(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getSnapshotCategory({commit},params){
      return new Promise((resolve, reject) => {
        GetSnapshotCategory(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    postSnapshot({commit},params){
      return new Promise((resolve, reject) => {
        PostSnapshot(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default CasualPatting



// WEBPACK FOOTER //
// ./src/store/modules/CasualPatting.js


// WEBPACK FOOTER //
// ./src/store/modules/CasualPatting.js